export const variables = {
    background: '#111111',
    colorFont: '#ECECEC',
    fontSize: '18px',
    colorFontTwo: '#272628'
}